import React, { Component } from 'react';
import PropTypes from 'prop-types';
import whiteBackground from '../wrapper-components/white-background';
import AttendeeSendInvitePageBody from './AttendeeSendInvitePageBody';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import SharedIntlProviderHOC from "shared-components/hocs/sharedIntlProviderHOC";

class AttendeeSendInvitePageShare extends Component {
  constructor (props) {
    super(props);

    this.redirectToPreview = this.redirectToPreview.bind(this);
  }

  redirectToPreview () {
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
    const publicBookingId = _.get(this.props, 'booking.booking.pid');
    this.props.dispatch(push(`${urlPrefix ? `/${urlPrefix}` : ''}/invite/${publicBookingId}`));
  }

  render () {
    return (
      <div className="AttendeeSendInvitePageShare style-2 flex center">
        <div className="content-container">
          <div>
            <h2>
              <FormattedMessage id='invite.attendee_send_invite_page_share.share_invite' defaultMessage='Share Invite' />
            </h2>
          </div>

          <AttendeeSendInvitePageBody
            {...this.props}
            pageType="share_invite"
            buttonText={ this.props.intl.formatMessage({ id: 'invite.attendee_send_invite_page_share.done', defaultMessage: 'Done' }) }
            cancelRedirect={this.redirectToPreview}
            showCancel
          />
        </div>
      </div>
    );
  }
}

AttendeeSendInvitePageShare.propTypes = {
  dispatch: PropTypes.func
};

const mapStateToProps = ({ booking }) => ({ booking });

export default injectIntl(connect(mapStateToProps)(whiteBackground(AttendeeSendInvitePageShare)));
